import React from "react";
import noCarAnimation from "../assets/noCar.json";
import Lottie from "lottie-react";
import InspectionShell from "../components/InspectionShell";

/**
 * Desktop “use mobile” alert for photo capture.
 * Optional title/badge mirror the checklist header (section name + Q1/3).
 */
function DeskTopView({
  onBack,
  title,
  badge,
  label = "Device",
}) {
  return (
    <InspectionShell
      badge={badge || "Mobile only"}
      title={title || undefined}
      mainClassName="pi-inspection-main--center"
      onBack={onBack}
      showFooter
    >
      <div className="pi-inspection-status-card pi-desktop-alert" style={{ textAlign: "center" }}>
        <p className="pi-inspection-label">{label}</p>
        <h1>{title || "Use a mobile device"}</h1>
        {badge ? (
          <p className="pi-desktop-alert__meta">{badge}</p>
        ) : null}
        <Lottie
          animationData={noCarAnimation}
          loop
          style={{ width: 220, height: 220, margin: "0 auto" }}
        />
        <p>
          Inspection capture needs an iPhone/iPad (iOS 13+) or Android 9+ with a
          camera. Open this checklist on your phone to add the photo.
        </p>
      </div>
    </InspectionShell>
  );
}

export default DeskTopView;
